import { Room } from '@material-ui/icons'
import { useState } from 'react'
import { Marker } from 'react-map-gl'
import PopupInfo from './PopupInfo'


const LocationMarker = ({ mark }) => {

    const [locationInfo, setLocationInfo] = useState(null)

    const markers = mark.map(ev => {
        if (ev.categories[0].id == 8) {
            return (
                <>
                    <Marker
                        latitude={ev.geometries[0].coordinates[1]}
                        longitude={ev.geometries[0].coordinates[0]}
                        offsetLeft={-20}
                        offsetTop={-10}
                    >
                        <Room style={{ color: 'tomato' }}
                            onClick={() => {
                                setLocationInfo({
                                    id: ev.id,
                                    title: ev.title,
                                    date: ev.geometries[0].date,
                                    coord: ev.geometries[0].coordinates,
                                    display: true
                                })
                            }} />
                    </Marker>
                </>

            )
        }
        return null
    })

    return (
        <>
            {markers}

            {locationInfo && (
                <PopupInfo info={locationInfo} />
            )}
        </>
    )
}

export default LocationMarker
